import React, { useState } from "react";
import Breadcrumb from "../components/Breadcrumb";
import { postData } from "../api/client";
import endpoints from "../api/endpoints";
import { useSiteContact } from "../api/siteLogo";

const defaultInfo = {
  address: process.env.REACT_APP_ADDRESS || "Kademy HQ, India",
  email: process.env.REACT_APP_EMAIL || "support@kademy.com",
  phone: process.env.REACT_APP_PHONE || "+91 99999 99999",
};

function Contact() {
  const siteContact = useSiteContact();
  const info = {
    address: siteContact.address || defaultInfo.address,
    email: siteContact.email || defaultInfo.email,
    phone: siteContact.phone || defaultInfo.phone,
  };

  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const [successMessage, setSuccessMessage] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccessMessage(null);

    if (!name || !phone || !message) {
      setError("Please provide all required fields.");
      return;
    }

    setLoading(true);
    try {
      const data = await postData(endpoints.CONTACT_CREATE, {
        name,
        phone,
        email,
        message,
      });

      setSuccessMessage(data?.message || "Message sent successfully");
      setName("");
      setPhone("");
      setEmail("");
      setMessage("");
    } catch {
      setError("Failed to send your message. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Breadcrumb title="Contact Us" path="Contact" />

      <section className="contact-page">
        <div className="container">
          <div className="contact-page-head">
            <p className="contact-kicker">Get in touch</p>
            <h1>
              Talk with the <span className="text-gradient">Kademy</span> team
            </h1>
            <p>
              Questions about a course, enrollment, or your account. Send a
              message and we will get back to you.
            </p>
          </div>

          <div className="contact-layout">
            <aside className="contact-aside">
              <a className="contact-card" href={`tel:${info.phone}`}>
                <span className="contact-card-icon" aria-hidden="true">
                  <i className="far fa-phone"></i>
                </span>
                <span>
                  <strong>Phone</strong>
                  <em>{info.phone}</em>
                </span>
              </a>

              <a className="contact-card" href={`mailto:${info.email}`}>
                <span className="contact-card-icon" aria-hidden="true">
                  <i className="far fa-envelope"></i>
                </span>
                <span>
                  <strong>Email</strong>
                  <em>{info.email}</em>
                </span>
              </a>

              <div className="contact-card">
                <span className="contact-card-icon" aria-hidden="true">
                  <i className="far fa-location-dot"></i>
                </span>
                <span>
                  <strong>Address</strong>
                  <em>{info.address}</em>
                </span>
              </div>
            </aside>

            <div className="contact-panel">
              <h2>Send a message</h2>
              <p className="contact-panel-lead">
                Share a few details and we will reply by email or phone.
              </p>

              {successMessage && (
                <div className="contact-alert contact-alert-success" role="status">
                  {successMessage}
                </div>
              )}

              {error && (
                <div className="contact-alert contact-alert-error" role="alert">
                  {error}
                </div>
              )}

              <form className="contact-fields" onSubmit={handleSubmit}>
                <div className="contact-field-row">
                  <label>
                    Name
                    <input
                      className="form-control"
                      placeholder="Your name"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      required
                    />
                  </label>
                  <label>
                    Phone
                    <input
                      className="form-control"
                      placeholder="Phone number"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                      required
                    />
                  </label>
                </div>

                <label>
                  Email <span>optional</span>
                  <input
                    type="email"
                    className="form-control"
                    placeholder="you@email.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </label>

                <label>
                  Message
                  <textarea
                    className="form-control"
                    rows="6"
                    placeholder="How can we help?"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    required
                  />
                </label>

                <button className="theme-btn" type="submit" disabled={loading}>
                  {loading ? "Sending..." : "Send message"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Contact;
